module.exports = __webpack_public_path__ + "static/media/account_circle.03bcb825.svg";